// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectBasketIsBoomActive,
  selectBasketItemsEntityIsBoomActive,
  selectBasketItemsEntityStatus,
  selectBasketMode,
  selectBasketStatus,
} from '../../../../selectors/basket/basketPrimary.selector';
import { BasketModes, BasketStatuses } from '../../../../types/basket';
import { type SelectorMaker, type Selector } from '../../../../types/selectors';
import { BoomAssetsBySkinId } from '../../constants/assets';
import { BoomLabelsBySkinId } from '../../constants/labels';
import { selectBasketBoomSkinId, selectBasketBoomState, selectBasketBoomStepId } from '../../selectors/basket.selector';
import { selectBoomGlobalSkinId } from '../../selectors/global/globalPrimary.selector';
import { selectIsBoomEnabled } from '../../selectors/runtime.selector';
import { selectIsBoomUserOptIn } from '../../selectors/user.selector';
import { type BoomSkinId } from '../../types/global';

const getOddIdFromProps = (_, { oddId, oddsId }) => oddId ?? oddsId;

type BoomBasketBetslipbandPropsType = {
  label: string;
  icon?: string;
  isVisible: boolean;
  skinId: BoomSkinId;
};

const makeBoomBasketBetslipbandPropsSelector: SelectorMaker<BoomBasketBetslipbandPropsType> = () => {
  const selectLabel: Selector<string> = createSelector(
    [selectBasketBoomState, selectBasketBoomSkinId, selectBasketBoomStepId],
    (boom, skinId, stepId) =>
      boom
        ? `${BoomLabelsBySkinId[boom.skinId]?.BetslipBandTitle} - ${
            BoomLabelsBySkinId[skinId]?.StepShortTitleByStepId[stepId] ?? ''
          }`
        : '',
  );

  const selectIcon: Selector<string | undefined> = createSelector(
    [selectBasketBoomState, selectBasketBoomSkinId],
    (boom, skinId) => (boom ? BoomAssetsBySkinId[skinId]?.BetslipIcon : ''),
  );

  const selectIsVisible: Selector<boolean> = createSelector(
    [
      getOddIdFromProps,
      selectBasketStatus,
      selectBasketMode,
      selectBasketItemsEntityStatus,
      selectBasketIsBoomActive,
      selectBasketItemsEntityIsBoomActive,
      selectIsBoomEnabled,
      selectIsBoomUserOptIn,
    ],
    (
      oddsId,
      basketStatus,
      basketMode,
      basketItemStatus,
      basketIsBoomActive,
      basketItemIsBoomActive,
      isBoomEnabled,
      isUserOptIn,
    ) => {
      if (isBoomEnabled && isUserOptIn) {
        if (basketMode === BasketModes.SIMPLE && basketItemStatus === BasketStatuses.VALIDATED) {
          return oddsId && basketItemIsBoomActive;
        }

        if (basketMode === BasketModes.COMBINED && basketStatus === BasketStatuses.VALIDATED) {
          return !oddsId && basketIsBoomActive;
        }
      }

      return false;
    },
  );

  return createSelector(
    [selectLabel, selectIcon, selectIsVisible, selectBoomGlobalSkinId],
    (label, icon, isVisible, skinId) => ({
      label,
      icon,
      isVisible,
      skinId,
    }),
  );
};

export default makeBoomBasketBetslipbandPropsSelector;
